export default __webpack_public_path__ + "images/5_thumbnail.jpg";